import { render, staticRenderFns } from "./LatestNew.vue?vue&type=template&id=04870edd"
import script from "./LatestNew.vue?vue&type=script&lang=js"
export * from "./LatestNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports